<template>
    <div v-if="memoryUsage" class="memory-usage">
        <div class="text-center">
            {{ memoryUsage }}
        </div>
        <div class="v-flex">
            <div class="primary memory-bar" :style="'height:' + this.usedInPercent + '%'" >

            </div>
            <div class="background-selected memory-bar" :style="'height:' + (100 - this.usedInPercent) + '%'">

            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "CAppMemory",

    data: () => ({
        memoryUsage: null,
        usedInPercent: null,
    }),

    computed: {
    },

    created() {
        this.$bus.$on(this.$events.refreshdocuments, this.memory);
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.refreshdocuments, this.memory);
    },

    mounted() {
        this.memory();
        window.setInterval(() => {
            this.memory();
        }, 10000);

    },

    methods: {
        memory () {
            const used = Math.trunc (window.performance.memory.usedJSHeapSize / 1024);
            const max  = Math.trunc (window.performance.memory.jsHeapSizeLimit / 1024);
            this.memoryUsage = (used / 1024).toFixed(1) + "M von " +(max / 1024).toFixed(1) + "M";
            if (used && max && max > 0) {
                this.usedInPercent = ( used * 100 / max ).toFixed(2);
            } else {
                this.usedInPercent = null;
            }
        }
    }
}
</script>

<style scoped>

.memory-usage {
    font-size: 13px;
    width: 50px;
    height: 175px;
}

.memory-bar {
    width: 20px;
}

</style>